// see refusalReasonCode's here https://docs.adyen.com/development-resources/testing/result-code-testing/adyen-response-codes
import { CheckoutV2FinalizeCartResult } from '@Pages/onestepcheckout'
import { BraintreeResponseV2 } from '@PaymentComponents/Braintree/Hooks/useBraintreeCheckoutResponse'

export const getBraintreeRefusalReasonCodeStringV2 = (finalizeCart: CheckoutV2FinalizeCartResult) => {
  const braintree = (finalizeCart.paymentPayload as unknown as BraintreeResponseV2)
  const { resultCode } = braintree
  const history = braintree.authorizePaymentMethod.transaction.statusHistory
  if (resultCode === 'GATEWAY_REJECTED') {
    const gatewayRejectedReason = history[0].GatewayRejectedEvent.gatewayRejectionReason
    if (gatewayRejectedReason === 'CVV') {
      return 'checkout:COF_PAYMENT_CARD_ERROR_CVC'
    }
    return 'checkout:COF_PAYMENT_CARD_ERROR_DEFAULT'
  }
  const { legacyCode } = history[0].ProcessorDeclinedEvent.processorResponse
  switch (legacyCode) {
    case '2010':
      return 'checkout:COF_PAYMENT_CARD_ERROR_CVC'
    case '2006':
    case '2004':
      return 'checkout:EXPIRY_DATE_IS_INVALID'
    case '2008':
    case '2005':
      return 'checkout:COF_PAYMENT_CARD_ERROR_INVALID_CARD_NUMBER'
    case '2043':
    case '2046':
    case '2044':
    case '2041':
      return 'checkout:COF_PAYMENT_CARD_ERROR_RESTRICTED'
    case '2107':
      return 'checkout:COF_PAYMENT_CARD_ERROR_NOT_PERMITTED'
    default:
      return history[0].ProcessorDeclinedEvent.declineType === 'HARD' ? 'checkout:COF_PAYMENT_CARD_ERROR_RESTRICTED' : 'checkout:COF_PAYMENT_CARD_ERROR_DEFAULT'
  }
}
